import { Box } from "@mui/material";
import { useState } from "react";

// COMPONENTS
import Navbar from "../components/Navbar";
import ViolationsList from "../components/ViolationsList";
import Footer from "../components/Footer";
import FeedbackAlert from "../components/FeedbackAlert";

// VIOLATIONS
export default function Violations({ setViolationCalculator, violations, isLoading }: ViolationsProps) {
    const [showNotification, setShowNotification] = useState(false);
    const [notificationText, setNotificationText] = useState('');

    // RETURN ELEMENT
    return (
        <>
            {/* NOTIFICATION */}
            <FeedbackAlert
                show={showNotification}
                timeout={6000}
                message={notificationText}
                onClose={() => setShowNotification(false)}
            />

            {/* BODY */}
            <Box sx={{ height: '100vh', overflowX: 'hidden', overflowY: 'scroll' }}>
                <Navbar />

                {/* MAIN BODY */}
                <Box component="main" sx={{ minHeight: '100vh', px: 5, pb: 2 }}>
                    <ViolationsList
                        setViolationCalculator={setViolationCalculator}
                        violations={violations}
                        setShowNotification={setShowNotification}
                        setNotificationText={setNotificationText}
                        isLoading={isLoading}
                    />
                </Box>

                {/* FOOTER */}
                <Footer />
            </Box>
        </>
    )
}
